import React from "react"
import { FloatingActionButton, SelectField, MenuItem } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import AccountHierarchyDefinitionItem from "./AccountHierarchyDefinitionItem"
import AccountHierarchyDefinitionForAccount from "./AccountHierarchyDefinitionForAccount"
import AccountStore from "../../../stores/AccountStore"
import AppStateStore from "../../../stores/AppStateStore"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import AddAccountHierarchyDefinitionDialog from "./AddAccountHierarchyDefinitionDialog"
import * as accountActions from "../../../actions/AccountActions"
import * as permissionHelper from "../../../helpers/permissionHelper"
import { IHierarchyDefinition } from "../../../models"
let saveTimeout
interface IProps {
    accountId: string
}
interface IState {
    allowJobForAccount: boolean
    allowPunchForAccount: boolean
    messageForDisablePunchesForAccount: string
    disableExpenseForAccount: boolean
    openAddHierarchyDefinitionDialog: boolean
    hierarchyDefinitionItems: IHierarchyDefinition[]
    editableStateArray: boolean[]
    payrollHierarchyLevelId: string
}

export default class AccountHierarchyDefinition extends React.Component<IProps, IState>  {
    private payrollDefinitionLevelId
    constructor(props) {
        super(props)
        this.state = {
            allowJobForAccount: AccountStore.getCurrentAccountSettings().AllowJob,
            allowPunchForAccount: AccountStore.getCurrentAccountSettings().AllowPunch,
            messageForDisablePunchesForAccount: AccountStore.getCurrentAccountSettings().MessageForDisablePunches,
            disableExpenseForAccount:  AccountStore.getCurrentAccountSettings().DisableExpense,
            hierarchyDefinitionItems: [],
            editableStateArray: null,
            openAddHierarchyDefinitionDialog: false,
            payrollHierarchyLevelId: AccountStore.getCurrentAccountSettings().PayrollHierarchyDefinitionLevelId ?
                AccountStore.getCurrentAccountSettings().PayrollHierarchyDefinitionLevelId :
                "account",
        }
        autobind(this)
        this.payrollDefinitionLevelId = null
    }

    componentDidMount() {
        const lengthItems = AccountStore.getCurrentAccount().HierarchyDefinitions.length
        const editableStateArray = []
        for (let i = 0; i < lengthItems; i++) {
            editableStateArray.push(false)
        }
        this.setState({ editableStateArray: editableStateArray })
        this.getHierarchyDefinitions()
        AccountStore.on("account_change", this.getHierarchyDefinitions)
    }

    componentWillUnmount() {
        AccountStore.removeListener("account_change", this.getHierarchyDefinitions)
    }

    getHierarchyDefinitions() {
        this.setState({
            allowJobForAccount: AccountStore.getCurrentAccountSettings().AllowJob,
            allowPunchForAccount: AccountStore.getCurrentAccountSettings().AllowPunch,
            messageForDisablePunchesForAccount: AccountStore.getCurrentAccountSettings().MessageForDisablePunches,
            disableExpenseForAccount:  AccountStore.getCurrentAccountSettings().DisableExpense,
            hierarchyDefinitionItems: AccountStore.getCurrentAccount().HierarchyDefinitions
        })
    }

    handleItemEditable(index) {
        const editableStateArray = this.state.editableStateArray
        editableStateArray[index] = !editableStateArray[index]
        this.setState({
            editableStateArray: editableStateArray
        })
    }

    handleItem(index, field, value) {
        const hierarchyDefinitionItems = this.state.hierarchyDefinitionItems
        hierarchyDefinitionItems[index][field] = value

        if (field === "EnablePunches" && !value) {
            hierarchyDefinitionItems[index].EnablePositions = false
            if (!hierarchyDefinitionItems[index].MessageForDisablePunches)
                hierarchyDefinitionItems[index].MessageForDisablePunches = strings.Punches_are_not_allowed_at_this_location
        }

        if (hierarchyDefinitionItems[index].EnablePunches)
            hierarchyDefinitionItems[index].MessageForDisablePunches = null

        this.setState({ hierarchyDefinitionItems: hierarchyDefinitionItems }, () =>
            (field !== "Label" && field !== "MessageForDisablePunches") &&
            this.saveHierarchyDefinitions()
        )
    }

    checkValidPayrollLevel(levelId) {
        if (levelId === "account") {
            return { isValid: true, payrollDefinitionLevelId: null }
        } else {
            const allHierarchyItems = AccountStore.getCurrentAccount().HierarchyItems
            const hierarchyItemForLevel = allHierarchyItems.filter((item) => item.HierarchyDefinitionId === levelId)
            if (hierarchyItemForLevel.length === 0) {
                return { isValid: false }
            } else {
                return { isValid: true, payrollDefinitionLevelId: levelId }
            }
        }
    }

    saveHierarchyDefinitions(cb = null) {
        if (saveTimeout) {
            clearTimeout(saveTimeout)
        }
        saveTimeout = setTimeout(() => accountActions.patchAccount(this.props.accountId, {
            HierarchyDefinitions: this.state.hierarchyDefinitionItems
        }).then(() => cb && cb()), 750)
    }

    saveAccountSettings(allowPunchForAccount: boolean, messageForDisablePunchesForAccount: string, allowJobForAccount: boolean, disableExpenseForAccount: boolean) {
        this.setState({ allowPunchForAccount, messageForDisablePunchesForAccount, allowJobForAccount, disableExpenseForAccount }, () => {
            if (saveTimeout) {
                clearTimeout(saveTimeout)
            }
            saveTimeout = setTimeout(() =>
                accountActions.patchAccount(this.props.accountId, {
                    AccountSettings: {
                        AllowJob: allowJobForAccount,
                        AllowPunch: allowPunchForAccount,
                        MessageForDisablePunches: messageForDisablePunchesForAccount,
                        DisableExpense: disableExpenseForAccount
                    }
                }),
                750
            )
        })
    }

    render() {
        return (
            <div>
                <FloatingActionButton
                    secondary
                    className="fixed-add"
                    style={{ top: -28, right: 20 }}
                    onTouchTap={() => this.setState({ openAddHierarchyDefinitionDialog: true })}
                >
                    <ContentAdd />
                </FloatingActionButton>
                {AccountStore.getTimecardEnabled() &&
                    <div style={{ marginBottom: 10 }}>
                        <SelectField
                            floatingLabelText={strings.Payroll_Hierarchy_Level}
                            value={this.state.payrollHierarchyLevelId}
                            onChange={(event, key, payload) =>
                                AppStateStore.setConfirmDialogContent({
                                    content: strings.Change_payroll_definition_as_GlobalAdmin,
                                    confirm: () => {
                                        if (this.state.payrollHierarchyLevelId === payload) return
                                        const checkResult = this.checkValidPayrollLevel(payload)
                                        const hierarchyDefinition = this.state.hierarchyDefinitionItems.find((item) => item.Id === payload)
                                        if (checkResult.isValid) {
                                            this.payrollDefinitionLevelId = checkResult.payrollDefinitionLevelId
                                            AppStateStore.setConfirmDialogContent({
                                                content: checkResult.payrollDefinitionLevelId === null ?
                                                    strings.All_employees_will_have_the_account_as_payroll_hierarchy :
                                                    strings.formatString(strings.By_changing_the_payroll_hierarchy_definition, hierarchyDefinition.Label) as string,
                                                confirm: () => {
                                                    AppStateStore.setProgressSnackbarContent("loading")
                                                    accountActions.updatePayrollDefinitionLevel(this.props.accountId, this.payrollDefinitionLevelId, () => {
                                                        this.setState({ payrollHierarchyLevelId: this.payrollDefinitionLevelId ? this.payrollDefinitionLevelId : "account", })
                                                        AppStateStore.setProgressSnackbarContent(strings.Successfully_updated)
                                                        this.payrollDefinitionLevelId = null
                                                    })
                                                }
                                            })
                                        }
                                        else {
                                            AppStateStore.setProgressSnackbarContent(strings.formatString(strings.xxx_hierarchy_definition_has_not_any_hierarchy_items, hierarchyDefinition.Label) as string)
                                        }
                                    }
                                })
                            }
                            disabled={!permissionHelper.isGlobalAdmin()}
                        >
                            <MenuItem value="account" primaryText={strings.Account} />
                            {this.state.hierarchyDefinitionItems.map((item, key) =>
                                <MenuItem value={item.Id} primaryText={item.Label} key={key} />
                            )}
                        </SelectField>
                    </div>
                }
                <AccountHierarchyDefinitionForAccount
                    allowPunch={this.state.allowPunchForAccount}
                    allowJob={this.state.allowJobForAccount}
                    messageForDisablePunches={this.state.messageForDisablePunchesForAccount}
                    disableExpense={this.state.disableExpenseForAccount}
                    handleChange={this.saveAccountSettings}
                />
                {this.state.hierarchyDefinitionItems.map((item, index) =>
                    <AccountHierarchyDefinitionItem
                        key={index}
                        item={item}
                        editable={this.state.editableStateArray[index]}
                        handleEditable={this.handleItemEditable}
                        handleItem={this.handleItem}
                        index={index}
                        handleBlur={this.saveHierarchyDefinitions}
                        explicitAccountUserHierarchyAssignment={AccountStore.getCurrentAccountSettings().HierarchySettings.DisableHierarchyItemsForAccountUserUnlessAssigned}
                        explicitEmployeeHierarchyAssignment={AccountStore.getCurrentAccountSettings().HierarchySettings.DisableHierarchyItemsForEmployeeUnlessAssigned}
                    />
                )}
                {this.state.openAddHierarchyDefinitionDialog &&
                    <AddAccountHierarchyDefinitionDialog
                        candidateLevel={this.state.hierarchyDefinitionItems.length}
                        explicitAccountUserHierarchyAssignment={AccountStore.getCurrentAccountSettings().HierarchySettings.DisableHierarchyItemsForAccountUserUnlessAssigned}
                        explicitEmployeeHierarchyAssignment={AccountStore.getCurrentAccountSettings().HierarchySettings.DisableHierarchyItemsForEmployeeUnlessAssigned}
                        handleSave={newHierarchyDefinitionItem => {
                            const hierarchyDefinitionItems = this.state.hierarchyDefinitionItems
                            hierarchyDefinitionItems.push(newHierarchyDefinitionItem)
                            const editableStateArray = this.state.editableStateArray
                            editableStateArray.push(false)
                            AppStateStore.setProgressSnackbarContent("loading")
                            this.setState({
                                hierarchyDefinitionItems,
                                editableStateArray,
                                openAddHierarchyDefinitionDialog: false
                            },
                                () => this.saveHierarchyDefinitions(() =>
                                    AppStateStore.setProgressSnackbarContent(strings.Successfully_added)
                                )
                            )
                        }}
                        handleClose={() => this.setState({ openAddHierarchyDefinitionDialog: false })}
                    />
                }
            </div >
        )
    }
}